import React from 'react'
import { Check, X } from 'lucide-react'
import { IReviewFeedback } from '../../model/review'
import styles from './styles.module.css'

interface IExecutionReviewFeedbackProps {
  kind: IReviewFeedback['kind']
}

export function ExecutionReviewFeedback({ kind }: IExecutionReviewFeedbackProps) {
  const Icon = kind === 'approved' ? Check : X

  return (
    <div className={`${styles.overlay} ${styles[kind]}`} data-review-feedback={kind} aria-hidden="true">
      <div className={styles.symbol}>
        <Icon size={64} strokeWidth={3} />
      </div>
    </div>
  )
}
